import { style } from '@vanilla-extract/css';

export const filterToggleGroup = style([
  {
    overflowX: 'auto',
    scrollbarWidth: 'none',
  },
]);

export const filterToggleItem = style([
  {
    whiteSpace: 'nowrap',
  },
]);
